import { ItineraryBookData } from './itinerary.interfaces';
import { generateFlight } from '@/api/Cart/cart.fake';
import {
    getDateAddingDuration,
    getDateSubtractingDuration,
} from '@shared/helpers/datetime/datetime';

export const generateItineraryData = (
    index: number,
    metadata?: {
        isRoundTrip?: boolean;
        carrierCode?: string;
    }
): ItineraryBookData => {
    const link = 'https://www.sembo.se';
    const days = index + 1;
    const fromDate = getDateSubtractingDuration(new Date(), {
        days,
    });
    const toDate = getDateAddingDuration(fromDate, {
        days: days + 4,
    });
    const flight = generateFlight(index, fromDate, toDate, metadata);

    return {
        Legs: flight.Legs,
        BookPrice: flight.Price,
        BookLink: link,
        RebookableBookLink: link,
        RebookableBookPrice: {
            ...flight.Price,
            Amount: flight.Price.Amount + (flight.PriceBreakdown?.RebookableFee?.Amount ?? 0),
        },
        Adults: 2,
        Children: 1,
        Infants: 1,
        BookItineraryId: flight.Id,
        RebookableItineraryId: `Rebookable-${flight.Id}`,
        ResultPageLink: link,
        NonRebookablePriceBreakdown: flight.PriceBreakdown
            ? { ...flight.PriceBreakdown, RebookableFee: null }
            : null,
        RebookablePriceBreakdown: flight.PriceBreakdown,
        PaymentDiscount: {
            Amount: 199.0,
            Currency: flight.Price.Currency,
        },
        PaymentDiscountMethodName: 'Trustly',
    };
};
export const metaFakeItineraryData: ItineraryBookData = generateItineraryData(0, {
    isRoundTrip: true,
});
